import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, PhoneIcon, HomeIcon } from 'lucide-react';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 1,
    ease: [0.16, 1, 0.3, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 md:px-14 py-6 transition-colors duration-500 ${scrolled ? 'bg-bg-glass backdrop-blur-md text-primary' : 'bg-transparent text-white'}`} data-id="element-130" data-mp="4lzw5fmzh30e">
      {/* Left group — back-to-site CTA + brand */}
      <div className="flex items-center gap-3 md:gap-5 shrink-0" data-id="element-131" data-mp="1kzzrseesq6hu">
        {/* Back to main website */}
        <a href="https://jrpdi.com.ph" target="_blank" rel="noopener noreferrer" aria-label="Back to JRP main website" className={`inline-flex items-center gap-2 rounded-full px-3 py-2 text-sm font-light tracking-wide transition-colors ${scrolled ? 'bg-primary/5 text-primary hover:bg-primary/10' : 'bg-white/15 text-white hover:bg-white/25 backdrop-blur-sm'}`} data-id="element-132" data-mp="9ozhakqrm20h">
          <HomeIcon className="w-4 h-4 shrink-0" strokeWidth={1.5} data-id="element-133" data-mp="3n4oyaoul4msc" />
          <span className="hidden sm:inline" data-id="element-134" data-mp="3s1xieuzan0w8">Home</span>
        </a>

        {/* Brand */}
        <a href="#top" className="flex items-center gap-2.5 group" data-id="element-135" data-mp="wflrt5rsdjv">
          <img src="https://cdn.magicpatterns.com/uploads/1XQazF3bMRoBsuVY3Rx58f/2.png" alt="JRP" className={`h-5 md:h-6 w-auto transition-[filter] duration-500 ${scrolled ? '' : 'brightness-0 invert'}`} data-id="element-136" data-mp="u2x6x5ib4xu" />
          <span className="font-heading text-base md:text-lg font-light tracking-tight" data-id="element-137" data-mp="39b61n8cz887t">
            Homes
          </span>
        </a>
      </div>

      {/* Right group — address + contact */}
      <div className="flex items-center gap-4 md:gap-8" data-id="element-138" data-mp="2wcyju4k3cnj8">
        {/* Location */}
        <a href="#top" className={`flex items-center gap-2 transition-colors ${scrolled ? 'text-accent' : 'text-white'}`} data-id="element-139" data-mp="3b0tcjky3mrwb">
          <MapPinIcon className="w-4 h-4 shrink-0" strokeWidth={1.5} aria-hidden="true" data-id="element-140" data-mp="362i155s5o9bz" />
          <span className="text-sm font-light tracking-wide" data-id="element-141" data-mp="2ddca9myuttdu">
            <span className="md:hidden" data-id="element-142" data-mp="2df5gj15k2blb">Campanilla</span>
            <span className="hidden md:inline" data-id="element-143" data-mp="2sb4p0cwkudqz">
              35 Campanilla, Ayala Westgrove Heights
            </span>
          </span>
        </a>

        {/* Contact — jumps to the enquiry section */}
        <a href="#contact" className={`flex items-center gap-2 transition-opacity hover:opacity-80 ${scrolled ? 'text-primary' : 'text-white/90'}`} aria-label="Go to contact section" data-id="element-144" data-mp="7jkyzdaeme7e">
          <PhoneIcon className="w-4 h-4 shrink-0" strokeWidth={1.5} aria-hidden="true" data-id="element-145" data-mp="a40uve3milwa" />
          <span className="hidden sm:inline text-sm font-light tracking-wide" data-id="element-146" data-mp="f1itaak0liq1">
            +63 917 526 0969
          </span>
        </a>
      </div>
    </motion.nav>;
}